import { PERMISSION_SUBJECTS } from '@/helpers/casl/ability';
import { useIsReviewingOtherUser } from '@/hooks/query/useQueryUser';
import { useSessionPermissionCheck } from '@/hooks/useSessionPermissionCheck';
import { useCurrentSessionId } from '@heidi/runtime/shell';

export function useCanChangeMicrophoneForCurrentSession(): boolean {
  const isReviewingOtherUser = useIsReviewingOtherUser();
  const sessionId = useCurrentSessionId();
  const { checkPermission } = useSessionPermissionCheck(sessionId);

  if (!isReviewingOtherUser) {
    return true;
  }

  return checkPermission(
    PERMISSION_SUBJECTS.TEAM_OTHERS_TRANSCRIPTION_CREATE,
    PERMISSION_SUBJECTS.TRANSCRIPTION_CREATE
  );
}
